import { CubeRequestConfig } from '../../../common/interface/cube-request-config.interface';

export interface GetSelfSentimentReportTimeSeriesRequestDto {
  params: {
    startDate: string;
    endDate: string;
  };
  config: CubeRequestConfig;
}
